import { render, staticRenderFns } from "./robbery-components.vue?vue&type=template&id=48ddfb0d&scoped=true"
import script from "./robbery-components.vue?vue&type=script&lang=ts"
export * from "./robbery-components.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ddfb0d",
  null
  
)

export default component.exports